const localeStorageKeys = {
  LAST_REQUEST: 'last-request',
  LAST_PAGE: 'last-page',
  FILMS: 'films',
  GENRES: 'genres',
  WATCHED_KEY: 'watchedVideoKey',
  QUEUE_KEY: 'queueVideoKey',
  TRAILER_KEY: 'local-trailer-key',
};

export const {
  LAST_REQUEST,
  LAST_PAGE,
  FILMS,
  GENRES,
  WATCHED_KEY,
  QUEUE_KEY,
  TRAILER_KEY,
} = localeStorageKeys;
